import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/userActions';
import LoadingCircle from '../widgets/LoadingCircle';
import { useIntl } from 'react-intl';

export default function RedirectToEnterprise() {
  const dispatch = useDispatch()
  const { $t } = useIntl()

  useEffect(() => {
    setTimeout(() => dispatch(logout(process.env.REACT_APP_KEY_USER_REDIRECT)), 2000)
    // eslint-disable-next-line
  }, [])

  return (<LoadingCircle text={$t({ id: "redirectEnterprise" })} />)
}
